import {useState} from "react";
import {
  useAssignMembershipToEnrollment,
  useMembershipTypes,
} from "../hooks/use-membership";
import {toast} from "sonner";

export default function AssignMembershipCard({enrollmentId}) {
  const [selected, setSelected] = useState("");
  const {data, isLoading} = useMembershipTypes({isActive: true, limit: 100});
  const assignMut = useAssignMembershipToEnrollment();

  const items = data?.data?.documents || [];

  const onAssign = async () => {
    if (!selected) return toast.info("Select a membership");
    try {
      await assignMut.mutateAsync({enrollmentId, membershipTypeId: selected});
      toast.success("Membership assigned");
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to assign");
    }
  };

  return (
    <div className="rounded-lg border bg-white p-4 space-y-3">
      <div className="text-sm font-semibold">Assign Membership</div>

      <select
        className="w-full rounded border px-3 py-2 text-sm"
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
      >
        <option value="">{isLoading ? "Loading…" : "Select membership"}</option>
        {items.map((m) => (
          <option key={m._id} value={m._id}>
            {m.title} — ₦{Number(m.amount || 0).toLocaleString("en-NG")}
          </option>
        ))}
      </select>

      <button
        onClick={onAssign}
        disabled={!selected || assignMut.isPending}
        className="w-full rounded bg-black px-4 py-2 text-sm text-white hover:bg-gray-900 disabled:opacity-60"
      >
        {assignMut.isPending ? "Assigning…" : "Assign"}
      </button>
    </div>
  );
}
